// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"528":"codemirror","909":"notifications","961":"returns"}[chunkId] + "." + {"528":"93a31db94597f2dde60d","909":"9b506999c314562590d5","961":"ede8f928b172a1f94f23"}[chunkId] + ".css";
};